import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { UserAccountContainer } from '@components/organisms/UserAccountContainer';
import { SpacesFilter, SpacesFilterValues } from '@components/molecules/SpacesFilter';
import { SpacesTable } from '@components/molecules/SpacesTable';
import { GetSpacesInput } from '@services/useGetSpaces';

export const AdminSpacesList: FC = () => {
    const { t } = useTranslation();
    const [filters, setFilters] = useState<GetSpacesInput>({});

    const handleApplyFilters = (newFilters: SpacesFilterValues) => {
        // Map SpacesFilterValues to GetSpacesInput
        const mappedFilters: GetSpacesInput = {
            search: newFilters.searchQuery,
            featuredType: newFilters.featuredType,
            spaceTypeUuids: newFilters.propertyTypes,
            areaMin: newFilters.areaMin,
            areaMax: newFilters.areaMax,
            spaceStatusUuid: newFilters.propertyCondition,
            spaceTypeCategory: newFilters.businessCategory,
            priceMin: newFilters.priceMin,
            priceMax: newFilters.priceMax,
        };
        setFilters(mappedFilters);
    };

    const handleClearFilters = () => {
        setFilters({});
    };

    return (
        <UserAccountContainer title={t('user-account-sidebar.my-spaces')}>
            <SpacesFilter
                onApplyFilters={handleApplyFilters}
                onClearFilters={handleClearFilters}
                showCreateAlert={false}
                showPriceSlider={false}
                showAreaFilter={false}
            />
            <SpacesTable filters={filters} perPage={10} />
        </UserAccountContainer>
    );
};
